import { useEffect, useLayoutEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { getColorTheme, COLOR_THEMES } from '@/utils/storage';
import { RebuildBlockLogo } from './RebuildBlockLogo';

const SimpleSplash = ({ onComplete }) => {
  const initialTheme = COLOR_THEMES[getColorTheme() || 'wisteria'] || COLOR_THEMES.wisteria;
  const [currentTheme, setCurrentTheme] = useState(initialTheme);

  useEffect(() => {
    // Get saved theme from localStorage
    const savedTheme = getColorTheme();
    setCurrentTheme(COLOR_THEMES[savedTheme] || COLOR_THEMES.wisteria);
    console.log('🎨 Splash screen using theme:', savedTheme);
    
    // Hide splash after 2 seconds
    const timer = setTimeout(() => {
      onComplete();
    }, 2000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  useLayoutEffect(() => {
    const savedTheme = getColorTheme();
    const theme = COLOR_THEMES[savedTheme] || COLOR_THEMES.wisteria;
    const root = document.documentElement;

    root.style.setProperty('--theme-primary', theme.primary);
    root.style.setProperty('--theme-secondary', theme.secondary);
    root.style.setProperty('--theme-accent', theme.accent);
    root.style.setProperty('--theme-light', theme.light);
    root.style.setProperty('--theme-btn-bg', theme.primary);
    root.style.setProperty('--theme-btn-hover', theme.secondary);
    root.style.setProperty('--theme-border', theme.secondary);
    root.style.setProperty('--theme-input-bg', `${theme.light}80`);
    root.style.setProperty('--theme-text-primary', theme.textPrimary || '#2D2D35');
    root.style.setProperty('--theme-text-secondary', theme.textSecondary || '#73737D');
    root.style.setProperty('--theme-logo-text', theme.logoText || '#F9F9FF');
    document.body.setAttribute('data-theme', savedTheme);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: currentTheme.light }}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full px-2"
      >
        <RebuildBlockLogo className="w-full h-auto" scaleText={1.1} fontWeight="700" />
      </motion.div>
    </motion.div>
  );
};

export default SimpleSplash;